import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faExclamationTriangle,
  faCheckCircle,
} from '@fortawesome/free-solid-svg-icons'

const DisplayMessage = ({ message, messageType }) => {
  return (
    <div>
      {messageType === 'error' && (
        <div className="error-container">
          <FontAwesomeIcon icon={faExclamationTriangle} size="lg" /> {message}
        </div>
      )}
      {messageType === 'success' && (
        <div className="success-container">
          <FontAwesomeIcon icon={faCheckCircle} size="lg" /> {message}
        </div>
      )}
      {messageType !== 'error' && messageType !== 'success' && (
        <div className="normal-container">{message}</div>
      )}
    </div>
  )
}

export default DisplayMessage
